export const VALIDATION = {
    VALIDATION_REQUEST: 'validatedByMe',
    CREATED_BY_ME: 'createdbyme',
    TABS: ['createdbyme', 'validatedByMe'],

};

export const STAT_TYPE = {
    AUTHOR: 'author',
    VALIDATOR: 'validator',
    VALIDATION_START: 2023
};

export const CARD_STATUS = {
    ACTION: 'Action Required',
    DUE: 'Due in',
    PENALTY: 'Penalty',
    POINT: 'Point',
    FILTER_STATUS: 'status',
};

export const VALIDATION_ACADEMIC = {
    [VALIDATION.CREATED_BY_ME]: {
        TARGET: 'Content Creation Target',
        CONTRIBUTION: 'Content Contribution',
        TARGET_BODY: "You're required to create unique question on Glorifire Authors daily to meet specified targets assigned to you for authoring. Create questions consistently to achieve these targets",
        CONTRIBUTION_BODY: "Content Contribution is the number of content items that have been created and approved during an academic year, such as questions, study materials, and tests."

    },
    [VALIDATION.VALIDATION_REQUEST]: {
        TARGET: 'Validation Target',
        CONTRIBUTION: 'Validation Contribution',
        TARGET_BODY: "You're required to validate questions on Glorifire Authors daily to meet specified targets assigned to you. Validate questions consistently to achieve these targets",
        CONTRIBUTION_BODY: "Each successful validation (irrespective of approval or rejection) contributes a score increase of 1. However, an incorrect validation leads to the loss of all accrued points for that question and an additional penalty of 1 point."
    }
}

export const ACADEMIC_STAT = {
    [VALIDATION.CREATED_BY_ME]: {
        TARGET: { LABEL: 'Ques. Creation Target', KEY: 'target' },
        CONTRIBUTION: { LABEL: 'Ques. Contribution', KEY: 'contributionPoints' },
        COMPLETED: { LABEL: 'Ques. Submitted', KEY: 'contribution' },
        APPROVED: { LABEL: 'Ques. Approved', KEY: 'published' },
        REJECTED: { LABEL: 'Ques. Rejected', KEY: 'rejected' },
        REVIEW: { LABEL: 'Ques. in Review', KEY: 'inReview' },
        DRAFT: { LABEL: 'Ques. in Draft', KEY: 'draft' }
    },
    [VALIDATION.VALIDATION_REQUEST]: {
        TARGET: { LABEL: 'Validation Target', KEY: 'target' },
        COMPLETED: { LABEL: 'Validation Completed', KEY: 'contribution' },
        APPROVED: { LABEL: 'Ques. Approved', KEY: 'approved' },
        REJECTED: { LABEL: 'Ques. Rejected', KEY: 'rejected' },
        REVIEW: { LABEL: 'Ques. Resubmitted', KEY: 'resubmitted' },
        DRAFT: { LABEL: 'Ques. in Draft', KEY: 'draft' }
    }
};

export const VALIDATION_DIALOG_INFO_TYPES = {
    LEGEND: 'legend',
    OTHER: 'other',
}

export const VALIDATION_DIALOG_DATA = {
    [VALIDATION.VALIDATION_REQUEST]: {
        [VALIDATION_DIALOG_INFO_TYPES.LEGEND]: [
            {
                title: 'Due in 7 days', 
                description: 'Questions highlighted with this require your immediate action. Failure to take action within 7 days will result in re-assignment of these questions to another faculty and loss of all validation points earned by you for such questions',
                class: 'dueText'
            },
            {
                title: 'Resubmitted', 
                description: 'You previously rejected this question with feedback. The author has resolved / challenged your feedback and resubmitted it for your review.',
                class: 'reSubmittedText'
            },
            {
                title: 'Approved', 
                description: "You gave your approval to this question. This only indicates the action you took on the question; it does not indicate the question's current publishing status.",
                class: 'approvedText'
            },
            {
                title: 'Rejected', 
                description: "This question was rejected by you. This only indicates the action you took on the content; it does not indicate the question's current publishing status.",
                class: 'rejectedText'
            },
            {
                title: 'Penalty', 
                description: 'You previously validated this question, but it was later discovered that your decision was incorrect. As a result, a penalty of -1 has been imposed for this content.',
                class: 'penaltyText'
            },
        ],
        [VALIDATION_DIALOG_INFO_TYPES.OTHER]: [
            {
                title: 'Validation Target', 
                description: "You're required to validate questions on Glorifire Authors daily to meet specified targets assigned to you. Validate questions consistently to achieve these targets.",
                class: 'light-peach'
            },
            {
                title: 'Validation Completed', 
                description: `The total number of validations you've completed so far in the selected academic year. You will earn point(s) for each validation, whether you approve a question or reject it. However, incorrect validations will result in deductions from this total as a penalty.

                The increment in points/questions is dependent on the type of question. For paragraph-type questions, this increases by the number of sub-questions and for matrix-type questions, this increases by the number of options in the question. `,
                class: 'blush-pink'
            },
            {
                title: 'Questions Approved', 
                description: 'The total number of unique questions approved by you',
                class: 'light-ivory'
            },
            {
                title: 'Questions Rejected', 
                description: 'The total number of unique questions rejected by you',
                class: 'lavender'
            },
            {
                title: 'Ques. Resubmitted', 
                description: 'The total number of questions resubmitted to you by the author for validation after addressing the provided feedback. You need to take action on these questions within 7 days.',
                class: 'mint-green'
            },
        ]
    },
    [VALIDATION.CREATED_BY_ME]: {
        [VALIDATION_DIALOG_INFO_TYPES.LEGEND]: [
            {
                title: 'Action Required', 
                description: 'This question needs your immediate attention. You must address all feedback received from the validator and then resubmit the question for further review.',
                class: 'dueText'
            },
            {
                title: 'Rejected', 
                description: 'The question has been rejected by the validator.',
                class: 'dueText'
            },
            {
                title: 'In Review', 
                description: "The question is currently being validated by a faculty member, or it's in the queue to be picked up for validation by a faculty member.",
                class: 'reSubmittedText'
            },
            {
                title: 'Published ', 
                description: 'The question is published in the "All Content" section of myLibrary and is available for use in tests or assignments across all centers.',
                class: 'vivid-blue'
            },
            {
                title: 'Draft', 
                description: 'This is an initial version or preliminary form of the question being created. You can make revisions or edits before submitting it for validation.',
                class: 'dark-gray'
            },
        ],
        [VALIDATION_DIALOG_INFO_TYPES.OTHER]: [
            {
                title: 'Question Creation Target', 
                description: "You're required to create unique question on Glorifire Authors weekly to meet specified targets assigned to you for authoring. Create questions consistently to achieve these targets.",
                class: 'light-peach'
            },
            {
                title: 'Question Contribution',
                class: 'baby-blue',
                description: `Question Contribution is the number of questions created by you that have been published (approved after validation) during the selected time window

                The increment in points/questions is dependent on the type of question. For paragraph-type questions, this increases by the number of sub-questions and for matrix-type questions, this increases by the number of options in the question.`
            },
            {
                title: 'Questions Submitted', 
                description: 'The total number of questions submitted by you for validation in the selected Academic Year, it includes questions in Published and In Review status. Rejected questions are not counted in this total.',
                class: 'blush-pink'
            },
            {
                title: 'Questions Approved', 
                description: 'The total number of questions published on Glorifire Authors after getting duly approved through the validation process.',
                class: 'light-ivory'
            },
            {
                title: 'Questions Rejected', 
                description: 'The total number of questions rejected by validator, awaiting  resolution and action on the feedback by you.',
                class: 'lavender'
            },
            {
                title: 'Questions In Review', 
                description: 'The total number of questions in "In Review" status.',
                class: 'mint-green'
            },
            {
                title: 'Questions In Draft', 
                description: 'The total number of questions in "Draft" status.',
                class: 'blush-pink'
            },
        ]
    }
}

export const CARD_INFO_TYPES = {
    CLASSES: 'classes',
    SUBJECTS: 'subjects',
    CHAPTERS: 'chapters',
    CONCEPTS: 'concepts',
    GOALS: 'goals',
}

export const CONTENT_CARD_MODAL_HEADERS = [
    {key: CARD_INFO_TYPES.CLASSES, value: 'Class'},
    {key: CARD_INFO_TYPES.SUBJECTS, value: 'Subject'},
    {key: CARD_INFO_TYPES.CHAPTERS, value: 'Chapter'},
    {key: CARD_INFO_TYPES.CONCEPTS, value: 'Concept'},
    {key: CARD_INFO_TYPES.GOALS, value: 'Goal'},
]

export const MAXIMUM_REVIEW_CHARACTERS = 1000;

export const OTHER_REASON_ID = '6638b3d86a63e2c87cad1157';

export const SORTING_ORDER = {
    ASCENDING: 'asc',
    DESCENDING: 'desc',
}

export const CHARACTER_LIMIT = {
    ERROR: 'Character limit exceeded',
    INFO: 'Max 1000 characters'
}

export const STUDENT_TABS_VISIBLE = [VALIDATION.CREATED_BY_ME, 'favourites'];
export const QUESTIONS_AVAILABLE_FOR_VALIDATION = "questions-available-for-validation";
export const API_ERROR_CODES = [400, 403, 500, 401];
export const DEFAULT_ERROR_MSG = 'Error Fetching Search Results';
export const CLEAR_ALL_TAGS_TOASTER_MSG = 'All tags are cleared';
export const TAGS_MAP: any = {
    assignmentsObjective: 'Assignment (Obj)',
    assignmentsSubjective: 'Assignment (Sub)',
    workbookObjective: 'Workbook (Obj)',
    workbookSubjective: 'Workbook (Sub)',
    archiveObjective: 'Archive (Obj)',
    archiveSubjective: 'Archive (Sub)',
    cppSubjective: 'CPP (Subjective)',
    cppObjective: 'CPP (Objective)',
    concept: 'Concept',
    chapter: 'Chapter',
    question: 'Question',
    testpapers: 'Test Paper',
    note: 'Notes',
    formulas: 'Formula Sheet',
    audios: 'Audio',
    videos: 'Video',
    subject: 'Subject',
    studymaterial: 'Study Material',
}